<template>
    <div class="container-center">
        <el-form class="msgex-form" label-width="140px" ref="form" :model="form" >
            <el-row>
                <el-col :span="7">
                    <el-form-item label="信息筛选：" >
                        <el-select size="medium" v-model="form.type" @change="getMsgexList">
                            <el-option key=""  label="全部"        value=""></el-option>
                            <el-option key="1" label="我提出的主题" value="1"></el-option>
                            <el-option key="2" label="我接收的主题" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="3" :offset="14"> <!--msgexDialogShow=true-->
                    <el-button type="warning" class="btn-theme" size="medium" @click="showMessageDialog" icon="el-icon-edit">信息发起</el-button>
                </el-col>
            </el-row>
        </el-form>


        <div class="msgex-list-box">
            <div class="no-data-tip" v-if="msgexList.length == 0"></div>
            <el-collapse accordion>
                <el-collapse-item v-for="(li,index) in msgexList" :name="index" :key="index">
                    <template slot="title">
                        <div class="msgex-title-top">
                            <template v-if="typeName == 'invitation'">
                                <img  v-bind:class="[(li.comeFrom=='0' ? '' : 'rotate'),'arrow','big']" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAIAAACZeshMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjMxNTdERUM4MUQzRDExRTg5RTUyRURDOTQ3REREQUMwIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjMxNTdERUM5MUQzRDExRTg5RTUyRURDOTQ3REREQUMwIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MzE1N0RFQzYxRDNEMTFFODlFNTJFREM5NDdERERBQzAiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MzE1N0RFQzcxRDNEMTFFODlFNTJFREM5NDdERERBQzAiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7Yx64zAAAC60lEQVR42lSTTYwURRTH36uv7p5xZ2Z33V0gLiwxGBLDl4YEQzTGQIIHYwhyxKMXbsYYLhwk3rzoyYteOJFwIAExMcarIihxjZEs2bAamNXsKAzz0V3dVa8e1TuJrHXp1931e/9X//cKOS7wGASw8BKUA9bwe961Nj8wswchSApABEp5IQFABQABk1U/LWAdMBMA6bDWf/DF91+7Ig+BkQVJ5U0CQqqYwVMpGGALLEH6KC9Ygfsj736yfO2Re+wMG0QRQBJEsRyAo7DAJNB/sJokQERAuj/sfnb7Wt+PfFNZtkQFK+0AM5aGwblKJwqeCgPGIzsGjfD3sPvx8pVBMfBISdrYKaYWWnMd3XxxbmnP1I6GbvhJmRyVtsAAfrXY+Pzn6z37L6FvBhghaxLxPM4HLfV80nl918E3dh3KIKkAzFbljaJ7YfmrUT4c+7xlEmfLseKOyUaBJBGxhyzFnF6Z3fvuSyemqQlyi2Ff3vnODvplKFWa5L4CLU2WjmwhSBhQbRbJaMTG/9RfvXzrG5Duf26f3Xs6S2fqMoJFoxwBViEVQrIsJAwlCKFSocbof334563eSt32AIMJrBvmoyOnF/VsFIXKN1BaJmbZLLnpMcMUAvrCSQE9HF9duxlkiJ4nEzgDbMvmh4dPzZvp6BMHb1AutbYtLS7NtRZS1RSiYTjpBGME3Buurw17wJSEzT5XTEbqVmP23KGTn/5wqR/yxONrO/cd3b4v2zRng8c/Pli5sbZ8v+z5FH75597zu+ch8GbZKH1sAItt2fz7L7893ZipHHf0M3HG4gR40G1ov7V4+PyrZ945cIy9vvvwrxI4ll7DGB2ienAi/1x78b39b85MPTuqbHQKLagKEsa4M4Xs+ML+D144ked5JFnU14FrdwKzJwp1nDOvDtZvP7obP5ILcezHzENmW4ccG3/xt28tFXFvDdt6Qomdi++R5HIzF+dErv7DLlDJgZhCXDHBil2POSLxRIABALzUteeTPofjAAAAAElFTkSuQmCC">
                            </template>
                            <template v-else>
                                <img  v-bind:class="[(li.comeFrom =='2' ? '' : 'rotate'),'arrow']" src="data:image/png;base64,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">
                            </template>
                            <span v-bind:class="[li.readFlag!='0' ? '' : 'unread']" @click.stop="getInfo($event, li.id, 1)" class="title big">{{ li.title || '#缺省#' }}</span>
                            <span class="date">{{ li.createDate }}</span>
                        </div>
                        <div class="msgex-title-btm">
                             <template v-if="typeName == 'invitation'">
                                <span class="dept">
                                    {{
                                        ( li.baseOrgUnitList && li.baseOrgUnitList.length!=0 )
                                        ? li.baseOrgUnitList.joinAt('fdisplaynameL2')
                                        : '#缺省#'
                                    }}
                                </span>
                            </template>
                            <template v-else>
                                <span class="dept"> {{ li.deptName?li.deptName: '#缺省#' }} </span>
                                <!-- <span class="dept"> {{ li.comeFrom == '2' ?(li.deptName?li.deptName: '#缺省#'): li.supplierName?li.supplierName:'#缺省' }} </span> -->
                            </template>

                            <template v-if="typeName == 'invitation'"> <!--招标类 -->
                                <el-button v-if="li.comeFrom=='1'" class="reply" @click.stop="msgexReply($event, li.id, 1)" type="text" size="small">回复</el-button>
                            </template>
                            <template v-else> <!--工程管理类 -->
                                <el-button v-if="(li.comeFrom != '2') && (li.baseMessageReponseList && li.baseMessageReponseList.length == 0) " class="reply" @click.stop="showReplyDialog(li)" type="text" size="small">回复</el-button>
                            </template>
                        </div>
                    </template>

                    <div v-if="!li.baseMessageReponseList || li.baseMessageReponseList.length==0" class="no-data-tip noreply"></div>
                    <div class="msgex-list" v-for="(_li,index) in li.baseMessageReponseList" :key="index">
                        <div class="msgex-title-top">
                            <template v-if="typeName == 'invitation'">
                                <img  v-bind:class="[(_li.comeFrom=='0' ? '' : 'rotate'),'arrow']" src="data:image/png;base64,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">
                            </template>
                            <template v-else>
                                <img  v-bind:class="[(_li.comeFrom =='2' ? '' : 'rotate'),'arrow']" src="data:image/png;base64,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">
                            </template>

                            <span v-bind:class="[_li.readFlag!='0' ? '' : 'unread']" @click.stop="getInfo($event, _li.id, 2)" class="title">回复：{{ li.title || '#缺省#' }}</span>
                            <span class="date">{{ _li.createDate }}</span>
                        </div>
                        <div class="msgex-title-btm">
                            <template v-if="typeName == 'invitation'">
                                <span class="dept">
                                    {{
                                        ( _li.baseOrgUnitList && _li.baseOrgUnitList.length!=0 )
                                        ? _li.baseOrgUnitList.joinAt('fdisplaynameL2')
                                        : '#缺省#'
                                    }}
                                </span>
                            </template>
                            <template v-else>
                                <span class="dept"> {{ _li.deptName?_li.deptName: '#缺省#'}} </span>

                                <!-- <span class="dept"> {{ _li.comeFrom == '2' ?(_li.deptName?_li.deptName: '#缺省#'): _li.supplierName?_li.supplierName:'#缺省'}} </span> -->
                            </template>
                            <template v-if="typeName == 'invitation'">
                                <el-button v-if="_li.comeFrom=='1'" class="reply" @click.stop="msgexReply($event, _li.id, 2, li.id)" type="text" size="small">回复</el-button>
                            </template>
                             <template v-else> <!--工程管理类 -->
                                <el-button v-if="_li.comeFrom != '2'" class="reply" @click.stop="showReplyDialog(_li,li)" type="text" size="small">回复</el-button>
                            </template>
                        </div>
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div><!-- .msgex-list-box -->

        <div class="block">
            <el-pagination
                background
                prev-text="上一页"
                next-text="下一页"
                layout="total, prev, pager, next"
                :page-size="10"
                :current-page="pager.pageNum"
                :total="pager.total"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>


        <div v-if="msgexDialogShow">
            <el-dialog title="信息发起" :visible.sync="msgexDialogShow" width="640px" @close="cancelAdd" center>
                <el-form class="" label-width="140px" ref="msgexForm" :model="msgexForm"  >
                    <!--招标类 -->
                    <el-form-item label="选择部门：" prop="orgsCheckedName" v-if="typeName == 'invitation'">
                        <el-input type="textarea" disabled :row="3" v-model="orgsCheckedName" size="medium"></el-input>
                        <el-tree
                            accordion
                            filter
                            show-checkbox
                            ref="msgexOrgTree"
                            node-key="id"
                            :render-after-expand="false"
                            :data="msgexOrgData"
                            :props="msgexOrgProps"
                            :filter-node-method="filterNode"
                            @check-change="handleCheckChange"
                        ></el-tree>
                    </el-form-item>
                    <!--质量管理类 -->
                    <el-form-item label="选择部门：" prop="" v-else>
                        <el-input type="textarea" disabled :row="3" v-model="projectCurrentChecked.name" size="medium"></el-input>
                        <el-tree
                            accordion
                            ref="msgexOrgTree"
                            node-key="id"
                            :render-after-expand="false"
                            :data="projectOrgList"
                            :props="projectOrgProps"
                            @current-change="projectHandleChange"
                        ></el-tree>
                    </el-form-item>

                    <el-form-item label="主题：" prop="title">
                        <el-input size="medium" v-model="msgexForm.title" clearable placeholder="请输入主题"></el-input>
                    </el-form-item>

                    <el-form-item label="内容：" prop="content" >
                        <el-input v-model="msgexForm.content" type="textarea" :rows="3" placeholder="请输入内容"></el-input>
                    </el-form-item>

                    <el-form-item label="附件：" prop="baseFileList" >
                        <el-upload
                            class="upload-demo"
                            multiple
                            :limit="20"
                            :action="uploadApi"
                            :file-list="msgexForm.baseFileList"
                            :before-upload="beforeUpload"
                            :on-success="addMsgexHandle"
                            :on-error="uploadError"
                            :on-remove="handleRemoveMsgex"
                            >
                            <el-button size="small" type="primary">上 传</el-button>
                            <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                                <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer"> <!--msgexDialogShow = false-->
                    <el-button @click="cancelAdd">取 消</el-button>
                    <el-button type="primary" @click="submitMsgex" :disabled="flag">提 交</el-button>
                </span>
            </el-dialog>
        </div>

        <div v-if="msgexReplyDialogShow">
            <el-dialog title="回 复" :visible.sync="msgexReplyDialogShow" width="640px" @close="cancelReply" center >
                <el-form class="" label-width="140px" :model="msgexReplyForm"  ref="msgexReplyForm">
                    <template v-if="typeName == 'invitation'">
                        <el-form-item label="部门：" prop="">{{ msgexInfoData2.orgUnitList.joinAt('fdisplaynameL2') }}</el-form-item>
                    </template>

                    <template v-else>
                        <el-form-item label="部门：" prop="deptName">{{ msgexInfoData2.deptName}}</el-form-item>
                    </template>

                    <el-form-item label="主题：" prop="title">{{ msgexInfoData2.title }}</el-form-item>

                    <el-form-item label="内容：" prop="content" >
                        <el-input v-model="msgexReplyForm.content" type="textarea" :rows="3" placeholder="请输入内容"></el-input>
                    </el-form-item>

                    <el-form-item label="附件：" prop="baseFileList" >
                        <el-upload
                            class="upload-demo"
                            multiple
                            :limit="20"
                            :action="uploadApi"
                            :file-list="msgexReplyForm.baseFileList"
                            :before-upload="beforeUpload"
                            :on-success="addMsgexReplyHandle"
                            :on-error="uploadError"
                            :on-remove="handleRemoveMsgexReply"
                        >
                        <el-button size="small" type="primary">上 传</el-button>
                            <div slot="tip" class="el-upload__tip">上传附件大小请不要超过100M。<br>
                                <span class="redTip">注意：附件上传出现绿色打勾标志，才表示上传成功。</span></div>
                        </el-upload>
                    </el-form-item>

                </el-form>

                <span slot="footer" class="dialog-footer"> <!--msgexReplyDialogShow = false-->
                    <el-button @click="cancelReply">取 消</el-button>
                    <el-button type="primary" @click="submitMsgexReply">提 交</el-button>
                </span>

            </el-dialog>
        </div>

        <el-dialog title="详 情" :visible.sync="msgexInfoDialogShow" width="640px" center>
            <el-row>
                <template v-if="typeName == 'invitation'">
                    <el-col :span="4" class="text-right">部门：</el-col><el-col :span="20">
                        {{
                            ( msgexInfoData.orgUnitList && msgexInfoData.orgUnitList.length!=0 )
                            ? msgexInfoData.orgUnitList.joinAt('fdisplaynameL2')
                            : '#缺省#'
                        }}
                    </el-col>
                </template>
                <template v-else>
                     <el-col :span="4" class="text-right">部门：</el-col><el-col :span="20">
                        {{msgexInfoData.projectName ? msgexInfoData.projectName :'#缺省'}}
                    </el-col>
                </template>
            </el-row>
            <el-row><el-col :span="4" class="text-right">主题：</el-col><el-col :span="20">{{ msgexInfoData.title }}</el-col></el-row>
            <el-row><el-col :span="4" class="text-right">内容：</el-col><el-col :span="20">{{ msgexInfoData.content?msgexInfoData.content:'#缺省' }}</el-col></el-row>
            <el-row>
                <el-col :span="4" class="text-right">附件：</el-col>
                <el-col :span="20">
                    <div v-if="msgexInfoData.baseFileList.length==0" class="no-data-tip"></div>
                    <ul v-else>
                        <li v-for="li in msgexInfoData.baseFileList" :key="li.id"><a
                            :href="downloadApi +'?fileId='+ li.id" target="_blank">{{ li.fileOldName?li.fileOldName:li.fileName }}</a></li>
                    </ul>
                </el-col>
            </el-row>
        </el-dialog>
    </div><!-- container-center -->

</template>

<script>
import banner from '@/assets/imgs/banner_inviteMng.png'
import util from '@/util'

export default {
    name: 'msgex-mng-list',
    props:{
        typeName:{
            type:String,
            default:'invitation'
        }
    },
    data () {
        return {
            activeName:'',
            orgsChecked: [],

            // 基本参数
            uploadApi: `${util.baseUrl}rest/file/upload`,
            downloadApi: `${util.baseUrl}rest/file/down`,
            supplierId: this.$root.stockId,

            // 信息互通列表
            msgexList: [],

            // 信息互通列表请求参数
            form: {type: ''},
            pager:{
                total: 0,
                pageNum: 1,
                pageSize: 10
            },

            // 信息发起
            msgexDialogShow: false,
            msgexOrgData: [],  // 部门列表
            projectOrgList:[] , // 工程管理类的部门列表
            msgexOrgFilter: '',
            msgexOrgProps: {children:'children', label:'text'},
            projectOrgProps:{children:'children', label:'name'},
            msgexForm: {
                orgIds: [],
                title: '',
                content: '',
                baseFileList: []
            },

            // 回复
            msgexReplyDialogShow: false,
            msgexReplyForm: {
                content: '',
                baseFileList: []
            },

            // 信息详情
            msgexInfoDialogShow: false,
            msgexInfoData: {
                baseFileList:[]
            },
            msgexInfoData2: {
                orgUnitList: [],
                baseFileList:[],
                messageId:'' , // 信息ID
                orgName:'', // 组织名称
                orgId:'', // 组织ID
                title:'' // 主题
            },
            projectCurrentChecked:{}, // 工程管理类选择的层级对象
            flag:false // 判断组织下是否有联系人  true = 没有联系人，无法保存
        }
    },
     created(){
        this.$root.navs = [{name:'信息互通',path:'/msgexList'}]
        this.$root.headImage.src = banner
        this.$root.isPublic = false;
    },
    mounted () {

        // dev test
        window.ji = this;

        // 获取列表
        this.getMsgexList();

    },
    watch: {
        msgexOrgFilter(val) {
            this.$refs.msgexOrgTree.filter(val);
        },
    },
    computed: {
        orgsCheckedName() {
             return this.orgsChecked.joinAt('text',',');
        }
    },
    methods: {

        // 分页处理
        handleCurrentChange (page) {
            this.pager.pageNum = page;
            this.getMsgexList();
        },

        // 获取信息互通列表
        getMsgexList () {
            let apiUrl = '';
            let params = {};
            if(this.typeName == 'invitation'){ // 招标类
                apiUrl = 'rest/api/msg/baseMsgList';
                params =  Object.assign(
                    {
                        supplierId: this.supplierId,
                        type: '1',
                        pageNum: this.pager.pageNum,
                        pageSize: this.pager.pageSize
                    },
                    this.form
                );
            }else{ // 工程管理类
                apiUrl = 'rest/api/msgSupplierToAdmin/baseMsgList';
                params = {
                    pageNum: this.pager.pageNum,
                    pageSize: this.pager.pageSize,
                    supplierId: this.supplierId,
                    type: this.form.type
                }
            }
            const loading = this.$loading({background:'rgba(255,255,255,0.5)'});
            this.$http.post(apiUrl,params).then((res)=>{
                loading.close();
                if(res.data.result) {
                    this.msgexList = res.data.value.list;
                    this.pager.total = res.data.value.count;
                    this.pager.pageNum = res.data.value.pageNo;
                } else {
                    this.$message({message: 'Error: 信息互通列表', type: 'error'})
                }
            })

        },

        // 获取信息互通详情
        getInfo (event, id, type) {
            const loading = this.$loading({background:'rgba(255,255,255,0.5)'});
            let apiUrl = '';
            if(this.typeName == 'invitation'){
                apiUrl = 'rest/api/msg/response/Info';
            }else{
                apiUrl = 'rest/api/msgSupplierToAdmin/selectResponse'
            }
            this.$http.post(apiUrl,{
                msgId: id,
                type: type
            }).then((res)=>{

                loading.close();
                this.msgexInfoDialogShow = true

                if(res.data.result) {
                    this.msgexInfoData = res.data.value || {baseFileList:[]};
                } else {
                    this.$message({message: 'Error: 信息互通详情获取失败', type: 'error'})
                }

                this.getMsgexList();

            })
        },

        // 点击信息发起显示发送信息弹框
        showMessageDialog(){
            this.msgexDialogShow = true;
            if(this.typeName == 'invitation'){ // 招标的部门列表
                this.getOrgs();
            }else{ // 工程管理的部门列表
                this.getProjectOrgList();
            }
        },

        // 获取部门列表
        getOrgs () {
            const loading = this.$loading({background:'rgba(255,255,255,0.5)'});
            this.$http.post('rest/api/msg/org/units',{
                supplierId: this.$root.stockId
            }).then((res)=>{
                loading.close();
                if(res.data.result) {
                    this.msgexOrgData = res.data.value;
                } else {
                    this.$message({message: 'Error: 部门列表获取失败', type: 'error'})
                }
            })
        },

        // 部门选择
        filterNode(value, data) {
            if (!value) return true;
            return data.text.indexOf(value) !== -1;
        },

        // 获取数选中的部门
        handleCheckChange(data, checked, indeterminate) {
            if(!data.children) {
                if(checked) {
                    this.orgsChecked.push(data);
                } else {
                    var id = data.id;
                    this.orgsChecked.forEach((data,index) => {
                        if(data.id == id) {
                            this.orgsChecked.splice(index,1);
                        }
                    })
                }
            }
        },

        // 获取当前选中的组织信息
        projectHandleChange(data){
            this.$set(this.projectCurrentChecked,'name',data.name);
            this.$set(this.projectCurrentChecked,'id',data.id);
            console.log(data,99);
            if(data.id){
                this.checkLinkman(data.id);
            }
        },

        // 上传验证
        beforeUpload(file){

            if(file.size/1024/1024 > 100) {
                this.$alert('上传附件大小请不要超过100M','文件过大！',{ type: 'error' })
                return false
            }

            if(!util.allowUpload(file.name)){
                this.$alert(`支持的文件类型：${util.acceptFileTypes.join(' | ')}`,'文件类型不支持，已取消上传！',{ type: 'error' })
                return false
            }
            return true
        },

        uploadError(){
            this.$message({message:'上传出错，请稍后再试。',type:'error'});
        },


        // 信息发起上传处理
        addMsgexHandle: function(response, file, fileList){
            // if(file.status=='success'){
                this.msgexForm.baseFileList = __getBaseFiles__(file,fileList)
            // }
        },

        // 信息发起上传删除处理
        handleRemoveMsgex: function(file, fileList) {
            this.msgexForm.baseFileList = this.msgexForm.baseFileList.filter(function(f){
                return f.uid !== file.uid
            });
        },

        // 发送信息
        submitMsgex: function() {
            if(this.typeName == 'invitation'){
                if (this.orgsChecked.length == 0) {
                    this.$message({message: '请选择部门', type: 'error'});
                    return
                }
            }else{
                if(!this.projectCurrentChecked || !this.projectCurrentChecked.id ){
                    this.$message({message: '请选择部门', type: 'error'});
                    return
                }
            }
            if (!this.msgexForm.title) {
                this.$message({message: '请输入主题', type: 'error'});
                return
            }
            if (!this.msgexForm.content) {
                this.$message({message: '请输入内容', type: 'error'});
                return
            }

            const loading = this.$loading({lock:true, background:'rgba(255,255,255,0.5)'});

            // 根据不同的tab调用不同的接口
            let apiUrl = '';
            let orgId = '';
            let orgParams = ''; // 传递的组织ID字段名
            if(this.typeName == 'invitation'){ // 招标类
                apiUrl = 'rest/api/msg/createMsg';
                orgId = this.orgsChecked.joinAt('id',';').split(';');
                orgParams = 'orgIds';
            }else{ // 工程管理类
                apiUrl = 'rest/api/msgSupplierToAdmin/createMsg'
                orgId = this.projectCurrentChecked.id;
                orgParams = 'deptId'
            }
            this.$http.post(apiUrl, {
                    supplierId: this.supplierId,
                    [orgParams]: orgId,
                    title: this.msgexForm.title,
                    content: this.msgexForm.content,
                    baseFileList: this.msgexForm.baseFileList
                }).then((res)=>{
                this.msgexDialogShow = false;
                loading.close();
                if(res.data.result) {
                    this.$message({message: '提交成功', type: 'success'});
                    this.cancelAdd();
                } else {
                    this.$message({message: 'Error: createMsg', type: 'error'})
                    this.cancelAdd();
                }
                this.getMsgexList();
            })

        },


        // 点击回复显示回复弹窗
        showReplyDialog(item,item2){
            console.log(item,item2);
            this.msgexReplyDialogShow = true; // 显示弹框
            this.msgexInfoData2.deptId = item.deptId || '';
            this.msgexInfoData2.deptName = item.deptName || '';
            console.log(item.title);
            this.msgexInfoData2.title = item.title? item.title : item2.title?item2.title:'#缺省';
            this.msgexInfoData2.messageId = item.messageId || item.id ;
            this.msgexInfoData2.parentId = item.parentId || this.msgexInfoData2.messageId;
            this.msgexInfoData2.supplierId = item.supplierId || '';
        },


        submitMsgexReply: function() {
            if (!this.msgexReplyForm.content) {
                this.$message({message: '请输入回复内容', type: 'error'});
                return
            }
            const loading = this.$loading({lock:true, background:'rgba(255,255,255,0.5)'});

            // 根据不同的tab传递不同的参数
            let apiUrl = '';
            let params = {};
            if(this.typeName == 'invitation'){
                apiUrl = 'rest/api/msg/createResponse';
                params = {
                    supplierId: this.supplierId,
                    messageId:  this.msgexInfoData2.messageId,
                    parentId:  this.msgexInfoData2.responseId,
                    deptId:  this.msgexInfoData2.orgUnitList.joinAt('fid'),
                    reponseContent: this.msgexReplyForm.content,
                    baseFileList: this.msgexReplyForm.baseFileList
                }
            }else{
                apiUrl = 'rest/api/msgSupplierToAdmin/createResponse';
                params = {
                    messageId:  this.msgexInfoData2.messageId,
                    parentId:  this.msgexInfoData2.parentId,
                    deptId:  this.msgexInfoData2.deptId,
                    reponseContent: this.msgexReplyForm.content,
                    baseFileList: this.msgexReplyForm.baseFileList,
                    supplierId: this.msgexInfoData2.supplierId,
                }
            }
            this.$http.post(apiUrl,params).then((res)=>{
                this.msgexDialogShow = false;
                loading.close();
                if(res.data.result) {
                    this.$message({message: '提交成功', type: 'success'});
                    this.cancelReply();

                } else {
                    this.$message({message: 'Error: createMsg', type: 'error'})
                    this.cancelAdd();
                }
                this.msgexReplyDialogShow = false;
                this.getMsgexList();
            })
        },

        // 回复上传处理
        addMsgexReplyHandle: function(response, file, fileList){
            // if(file.status=='success'){
                this.msgexReplyForm.baseFileList = __getBaseFiles__(file,fileList)
            // }
        },

        // 回复上传删除处理
        handleRemoveMsgexReply: function(file, fileList) {
            this.msgexReplyForm.baseFileList = this.msgexReplyForm.baseFileList.filter(function(f){
                return f.uid !== file.uid
            });
        },

        // 回复
        msgexReply (event, id, type, parentId) {

            this.$http.post('rest/api/msg/response/Info',{
                msgId: id,
                type: type
            }).then((res)=>{
                if(res.data.result) {
                    this.msgexInfoData2 = res.data.value || {baseFileList:[]};
                    this.msgexInfoData2.messageId = parentId || id;
                } else {
                    this.$message({message: 'Error: 信息互通详情获取失败2', type: 'error'})
                }
            })

            this.msgexReplyDialogShow = true;

        },

        // 表单重置
        resetForm () {
            this.$refs['msgexOrgTree'].setCheckedNodes([]);


            this.msgexForm = {
                orgIds: [],
                title: '',
                content: '',
                baseFileList: []
            }

            this.msgexReplyForm = {
                title: '',
                content: '',
                baseFileList: []
            }
        },

        // 获取工程管理下属的部门
        getProjectOrgList(){
            const loading = this.$loading({background:'rgba(255,255,255,0.5)'});
            this.$http.post('rest/api/msgSupplierToAdmin/project',{}).then((res)=>{
                loading.close();
                if(res.data.result) {
                    this.projectOrgList = res.data.value;
                } else {
                    this.$message({message: 'Error: 部门列表获取失败', type: 'error'})
                }
            })
        },

        // 取消
        cancelReply(){
            this.msgexReplyDialogShow = false;
            this.$refs['msgexReplyForm'].resetFields();
            this.orgsChecked = [];
            // this.msgexReplyForm = {
            //     content: '',
            //     baseFileList: []
            // }
        },

        // 取消新增
        cancelAdd(){
            this.msgexDialogShow = false;
            this.$refs['msgexForm'].resetFields();
            this.msgexForm = {
                orgIds: [],
                title: '',
                content: '',
                baseFileList: []
            }
            this.projectCurrentChecked = {};
            this.orgsChecked = [];

        },

        // 判断点击的组织是否有联系人
        checkLinkman(id) {
            if(id){
                this.$http.post('/rest/api/msgSupplierToAdmin/selectPersonAndOrgByOrgId',{"orgId": id}).then((res)=>{
                    console.log(res,8880);
                    if(res.data.result){
                        if(res.data.value){
                            if(res.data.value.length){
                                if(!res.data.value[0].user.id){
                                    this.flag = true;
                                }else{
                                    this.flag = false;
                                }
                            }else{
                                this.flag = true;
                            }
                            if(this.flag){
                                this.$message({
                                    type:'error',
                                    message:'该组织下无联系人，无法发起信息！'
                                })
                            }
                        }
                    }
                })
            }
        },
    },
}

function __getBaseFiles__(file,fileList){
    let fs = [];
    fileList.forEach(function (item) {
        console.log(item)
        if(item.response){
            let f = item.response.basefiles[0];
            item.bizTableName =  f.biztablename;
            item.bizTablePkName =  f.biztablepkname;
            item.bizTablePkValue =  f.biztablepkvalue;
            item.fid =  f.fid;
            item.fileCatagoryId = f.filecatagoryid;
            item.fileDesc = f.filedesc;
            item.fileOldName = f.fileoldname;
            item.name = f.fileoldname;
            item.fileName = f.filename;
            item.filePath = f.filepath;
            item.fileSize = f.filesize;
            item.fileType = f.filetype;
            item.sort = f.sort;
        }
        fs.push(item);
    });
    console.log(fs);
    return fs
}

</script>

<style scoped lang="postcss">
@import '../../../../assets/common.css';

a {color:var(--cMain);}

ul {padding: 0;margin:0;}
ul li {list-style:none;}

.msgex-form {background: #F5F6F5;padding: 25px 10px 10px 10px;margin: 24px 0;}
.msgex-list {padding:20px 0 10px 48px;border-top:1px dashed #E4E5E4;}
.msgex-list .msgex-title-top .title {line-height:48px;}

.msgex-title-top .arrow {margin-right:4px;}
.msgex-title-top .arrow.big {margin-left:20px;}
.msgex-title-top .arrow.rotate {transform:rotate(180deg);}

.msgex-list-box .title {font-size:16px;cursor:pointer}
/*.msgex-list-box .title.big {margin-left:20px;}*/
.msgex-list-box .title.unread {font-weight:bold;}
.msgex-list-box .title.unread::before {content:'';position:relative;margin-right:8px;top:-2px;display:inline-block;width:8px;height:8px;border-radius:8px;background:var(--cMain);}
.msgex-list-box .date {float:right;color:#8c8c8c;}
.msgex-list-box .dept {max-width:1000px;color:#777;padding-left:40px;display:inline-block;line-height:28px;background:url() no-repeat center left;background-image:url('data:image/png;base64,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');}
.msgex-list-box .reply {float:right;color:#636363;padding-left:20px;display:inline-block;line-height:28px;background:url() no-repeat center left;background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAOCAIAAAB/6NG4AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkE2NTg3NEMwMUQzMDExRTg4MUNERTA2OTA4NzA1ODgxIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkE2NTg3NEMxMUQzMDExRTg4MUNERTA2OTA4NzA1ODgxIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QTY1ODc0QkUxRDMwMTFFODgxQ0RFMDY5MDg3MDU4ODEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QTY1ODc0QkYxRDMwMTFFODgxQ0RFMDY5MDg3MDU4ODEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz76O1RQAAACFElEQVR42iSRTUtVURSG37U/zjn33KvXD1LBTKGcFCiENikion5EBM37HVGBAwdCAwc5l2ZOgqIGDUJq0qiUsiZBZeZVr+ee/XH2Xm1wj9Z62ay1n2cTb6/23m8WR59j2TVUZP64ncsDF7rNCBWDypqhcqhfW9eZmrz2gPqrl8rbj8TcdXgPUCCSyKCd94pb1mG4c3KErPH7H4/frKjorJhcqrozefRRgAEZJAvSRA69AqPIzkGCmPPDX8IJg1i1AxRrC00gxAAiNGlFRwUECUSrYlCqUFlEVAgCCuggHRU0QmStuEHUgKAYIbzkwqdbkYUqdON590W9dpWqQ7JBb9wy2xsacvBp3azfEV5kHn2pBGHEDyxrqoans7ll6Fxk0k0uqO48QxTjF83MIgpD1PaFhHsyG35/scyWw4BdKhpmw8y+dnzKgZ3nOrU/d6unpTDxRMBnNlkyAjphyMAyMcr0vNikSCJHjMQWEwJZGSgbJEYqk8Q02EtS0TaUAIdS7MhR9KKTF/6vCC4n0culh99n0kq6Jonhdo3ghENIP5AxclOfNq2Sms37/X8/0B4jPd6+95zfrtD0kpy/Sztb/GGtJwoKcbRBZQ9aE1eSzBOzt9Oye274vJy5IXa3/rx8PDW3fPj99djNh1X3csZ18mv0bHFhARwT8OBMBcckI7hvr8yzxfD1XTLkU9hYjoMzUf8FGADOHjRSE/d3JQAAAABJRU5ErkJggg==");}
.msgex-list-box .title:hover,
.msgex-list-box .reply:hover {color:var(--cMain);}

</style>



// WEBPACK FOOTER //
// src/pages/dsp/msgex/comps/msgexList.vue